export default __webpack_public_path__ + "static/media/luna.2cb43a4d.jpg";